import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  ModalSpan,
} from '../../../components/modal/Modal';
import { withTranslate, TranslateHTML, Translate } from 'core/translate';
import { Button } from 'core/controls/button/Button';
import {
  trackModalLoaded,
  trackStateChanged,
} from '../../../factories/analytics/analytics.service';

const ResetWarning = ({
  option,
  packages,
  onClose,
  onReset,
  onSaveStartOver,
  translate,
  step,
}) => {
  const header = translate('build.assistant');
  const optionName = option.description || option.trimName;
  const packageString = _.flatMap(packages, (x) => x.options)
    .filter((x) => x.selected)
    .map((x) => x.description)
    .join(', ');

  useEffect(() => {
    trackModalLoaded('build assistant modal');
    return () => {
      trackStateChanged(step, true);
    };
  }, []);

  return (
    <Modal
      className="reset-warning"
      isOpen={true}
      contentLabel={header}
      onRequestClose={onClose}>
      <ModalHeader
        className="reset-warning__header"
        text={header}
        onClose={onClose}
        analyticsKey="configuration assistant"
      />
      <ModalBody innerClassName="reset-warning__body">
        <div className="reset-warning__description">
          {packageString ? (
            <>
              <TranslateHTML value="select.config.warning.start.v3" />
              <span className="reset-warning__description__option-name">
                {optionName}
              </span>
              <TranslateHTML
                value="select.config.warning.with.package.end.v3"
                package={packageString}
              />
            </>
          ) : (
            <>
              <TranslateHTML value="select.config.warning.start.v3" />
              <span className="reset-warning__description__option-name">
                {optionName}
              </span>
              <TranslateHTML
                value="select.config.warning.without.package.end.v3"
                package={packageString}
              />
            </>
          )}
        </div>
        <div className="reset-warning__selection-label">
          <TranslateHTML value="continue.with.new.config" config={optionName} />
        </div>
        <Button
          className="reset-warning__primary-button reset-warning__continue-button stat-button-link"
          data-dtm="configuration assistant"
          onClick={onReset}>
          <Translate value="byo.page.general.ok" />
        </Button>
        <div className="reset-warning__selection-label">
          <Translate value="save.current.build.first" />
        </div>
        <Button
          className="reset-warning__primary-button reset-warning__save-button stat-button-link"
          data-dtm="configuration assistant"
          onClick={onSaveStartOver}>
          <Translate value="save.and.start.new.build" />
        </Button>
      </ModalBody>
      <ModalFooter
        className="reset-warning__modal-footer"
        innerClassName="reset-warning__modal-footer__inner">
        <ModalSpan
          className="reset-warning__cancel-button stat-text-link"
          analytics="text"
          analyticsKey="configuration assistant"
          onClose={onClose}>
          <Translate value="byo.page.general.cancel" />
        </ModalSpan>
      </ModalFooter>
    </Modal>
  );
};

ResetWarning.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default withTranslate(ResetWarning);
